export const AUTH_ROUTES = {
  signIn: '/signin',
  createAccount: '/create-account',
  forgotPassword: '/forgot-password',
};

export const APP_ROUTES = {
  root: '/app',
  dashboard: '/app/dashboard',
  chat: '/app/chat',
  chatThread: '/app/chat/:threadId',
  profile: '/app/profile',
  financialInfo: '/app/financial-info',
  accounts: '/app/accounts',
  billing: '/app/billing',
  upgrade: '/app/upgrade',
  feedback: '/app/feedback',
};

export const ROUTE_ACCESS = {
  publicOnly: Object.values(AUTH_ROUTES),
  protected: Object.values(APP_ROUTES),
};

export const APP_ROUTE_INTENTS = {
  [APP_ROUTES.root]: { surface: 'app', mode: 'default' },
  [APP_ROUTES.dashboard]: { surface: 'dashboard', mode: 'overview' },
  [APP_ROUTES.chat]: { surface: 'chat', mode: 'new' },
  [APP_ROUTES.chatThread]: { surface: 'chat', mode: 'thread' },
  [APP_ROUTES.profile]: { surface: 'modal', modal: 'profile' },
  [APP_ROUTES.financialInfo]: { surface: 'modal', modal: 'financialInfo' },
  [APP_ROUTES.accounts]: { surface: 'modal', modal: 'accounts' },
  [APP_ROUTES.billing]: { surface: 'modal', modal: 'billing' },
  [APP_ROUTES.upgrade]: { surface: 'page', page: 'upgrade' },
  [APP_ROUTES.feedback]: { surface: 'modal', modal: 'feedback' },
};

export function getRootRedirect(isAuthenticated) {
  return isAuthenticated ? APP_ROUTES.dashboard : AUTH_ROUTES.signIn;
}

export function getProtectedRouteRedirect(pathname) {
  return {
    pathname: AUTH_ROUTES.signIn,
    state: { from: { pathname } },
  };
}

export function getPublicOnlyRedirect(locationState) {
  const fromPath = locationState?.from?.pathname;
  return isAppPath(fromPath) ? fromPath : APP_ROUTES.dashboard;
}

export function isAppPath(pathname) {
  return typeof pathname === 'string' && (pathname === APP_ROUTES.root || pathname.startsWith(`${APP_ROUTES.root}/`));
}

export function getChatThreadPath(threadId) {
  return `${APP_ROUTES.chat}/${encodeURIComponent(threadId)}`;
}

export function getAppRouteIntent(pathname) {
  if (!isAppPath(pathname)) return null;
  if (/^\/app\/chat\/[^/]+$/.test(pathname)) return APP_ROUTE_INTENTS[APP_ROUTES.chatThread];
  return APP_ROUTE_INTENTS[pathname] || null;
}
